<template>

  <div id="app">
  	<!-- <vue-canvas-nest></vue-canvas-nest> -->
  	<!-- <div style="height: 3000px;z-index: -1;position: fixed;height: 1000px;width: 100%;">
  		<vue-canvas-nest :config="{color:'28,28,28', count: 100,opacity:0.7}"></vue-canvas-nest>
  	</div> -->
  		
  	
	<ShortcutOperation v-if="shortcutOperation_show"></ShortcutOperation>
	<Header v-if="header_show"></Header>
	<!-- 页面内容 -->
	<div class="pages_container">
		<keep-alive>
			<router-view
				v-if="isRouterAlive && this.$route.meta.keepAlive"
				@header="header"
				@footer="footer"
				@shortcutOperation="shortcutOperation">
			</router-view>
		</keep-alive>
		<router-view
			v-if="isRouterAlive && !this.$route.meta.keepAlive"
			@header="header"
			@footer="footer"
			@shortcutOperation="shortcutOperation">
		</router-view>
	</div>
	<Footer v-if="footer_show"></Footer>
  </div>
</template>

<script>
const wx = require('weixin-js-sdk');
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ShortcutOperation from '@/components/ShortcutOperation.vue';
import rem from '@/assets/js/rem.js';

export default {
	name: 'App',
	provide (){//父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
		return {
			reload: this.reload
		}
	},
	data() {
		return{
			isRouterAlive: true, //控制视图是否显示的变量
			header_show: true,
			footer_show: true,
			shortcutOperation_show: true
		}
	},
	created(){
		// 微信分享
		const url = window.location.href.split('#')[0] //向服务端提供授权url参数，并且不需要#后面的部分
		this.axios.get( this.$global.apiUrl.wxuser_signature, {
			params: {
				url: url
			}
		})
		.then((response) => {
			if( response.data.error.code == 0 ){
				wx.config({
					debug: false, // 开启调试模式,
					appId: response.data.signPackage.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: response.data.signPackage.timestamp, // 必填，生成签名的时间戳
					nonceStr: response.data.signPackage.nonceStr, // 必填，生成签名的随机串
					signature: response.data.signPackage.signature, // 必填，签名，见附录1
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
				});
			}
		})
	},
	methods: {
		// 刷新效果
		reload () {
			this.isRouterAlive = false; //先关闭，
			this.$nextTick(function () {
				this.isRouterAlive = true; //再打开
			})
		},
		//是否显示头部
		header:function (bool) {
			this.header_show = bool;
		},
		//是否显示底部
		footer:function (bool) {
			this.footer_show = bool;
		},
		//是否显示返回顶部操作栏
		shortcutOperation:function (bool) {
			this.shortcutOperation_show = bool;
		},
	},
	mounted(){
		rem.init();
		// 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
		// window.onbeforeunload = function (e) {
		// 	var storage = window.localStorage;
		// 	storage.clear()
		// }
	},
	components: {
		Header,
		Footer,
		ShortcutOperation
	}
}
</script>